class PassKeyHelper {
	/**
	 * Generates a passkey required to post to the legacy BPK services
	 *
	 * @param {string} application - This has to match the application name on the web service
	 */
	async generatePassKey(application: string = import.meta.env.VITE_API_APP_NAME) {
		let passkeystring = application.toLowerCase();
		const secret = import.meta.env.VITE_API_APP_SECRET;
		const now = new Date();
		const month = now.getUTCMonth() + 1;
		const day = now.getUTCDate();
		const year = now.getUTCFullYear();
		const shortDateString = `${month}/${day}/${year}`;

		passkeystring = passkeystring + secret + shortDateString;
		const generatedKey = await this.generateSHA256String(passkeystring);

		return generatedKey;
	}

	private async generateSHA256String(input: string): Promise<string> {
		const encoder = new TextEncoder();
		const data = encoder.encode(input);
		const hashBuffer = await crypto.subtle.digest('SHA-256', data);
		const hashArray = Array.from(new Uint8Array(hashBuffer));
		const hashHex = hashArray.map((byte) => byte.toString(16).padStart(2, '0').toUpperCase()).join('');
		return hashHex;
	}
}

const passKeyHelper = new PassKeyHelper();
export default passKeyHelper;
